// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import './i18n';  // ✅ 초기화가 앱 시작 시점에 실행되도록
import MainPage from "./pages/MainPage/MainPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import SignUpPage from "./pages/SignUpPage/SignUpPage";
import FindPage from "./pages/FindPage/FindPage";

import Edituserinformation from "./components/Popup/Edituserinformation/Edituserinformation";
import Myinformation from "./components/Popup/Myinformation/Myinformation";
import UserDelete from "./components/Popup/UserDelete/UserDelete";

import AddProjectGroup from "./components/Popup/AddProjectGroup/AddProjectGroup";
import DataUpload from "./components/Popup/DataUpload/DataUpload";
import DeleteProject from "./components/Popup/DeleteProjectGroup/DeleteProjectGroup";
import UserCreate from "./components/Popup/UserCreate/UserCreate";

// AuthContext (로그인 상태, 권한 제공)
import { AuthProvider, useAuth } from "./context/AuthContext";
import RoleProtectedRoute from "./routes/RoleProtectedRoute";
import { ProjectProvider } from "./ProjectContext";
import EditProjectGroup from "./components/Popup/EditProjectGroup/EditProjectGroup";
import EditProject from "./components/Popup/EditProject/EditProject";

function AppRoutes() {
  const { isAuthenticated, userRole, authLoading } = useAuth();

  if (authLoading) return <div>Loading...</div>;

  return (
    <ProjectProvider>
    <Routes>
      {/* 메인 */}
      {/* 로그인 */}
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <LoginPage />
          )
        }
      />

      {/* 회원가입 */}
      <Route
        path="/signup"
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <SignUpPage />
          )
        }
      />

      {/* 아이디/비번 찾기 */}
      <Route
        path="/find"
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <FindPage />
          )
        }
      />

      {/* 사용자 마이페이지 관련 팝업들 - 로그인 사용자만 접근 가능 */}
      <Route
        path="/"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<MainPage />}
          />
        }
      />
      <Route
        path="/mypage/edit"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<Edituserinformation />}
          />
        }
      />
      <Route
        path="/mypage/info"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<Myinformation />}
          />
        }
      />
      <Route
        path="/mypage/delete"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_USER", "ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<UserDelete />}
          />
        }
      />

      {/* 프로젝트 관리 - 관리자만 접근 가능 */}
      <Route
        path="/project/editprojectgroup"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<EditProjectGroup />}
          />
        }
      />
      <Route
        path="/project/editproject"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<EditProject/>}
          />
        }
      />
      <Route
        path="/project/add"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<AddProjectGroup />}
          />
        }
      />
      <Route
        path="/project/upload"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<DataUpload />}
          />
        }
      />
      <Route
        path="/project/delete"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<DeleteProject />}
          />
        }
      />
      <Route
        path="/user/create"
        element={
          <RoleProtectedRoute
            requiredRoles={["ROLE_ADMIN", "ROLE_SUPERUSER"]}
            element={<UserCreate />}
          />
        }
      />
     
    </Routes>
    </ProjectProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
